module.exports = __webpack_public_path__ + "img/national-payment-system-mir.d918057e.svg";